import {
  CreateUserAccountDto,
  CreateUserAccountResponse,
} from "../../../@types/Users";
import { api } from "../../api";

export default async function create(
  dto: CreateUserAccountDto
): Promise<CreateUserAccountResponse | null> {
  try {
    const { data } = await api.post("/auth/register", dto);

    return data as CreateUserAccountResponse;
  } catch (err: any) {
    console.log(err);
    return err.response.data;
  }
}
